import clsx from 'clsx';
import { LinkText, Icon } from 'components';
import { useNavigate } from 'react-router-dom';
import { colors } from 'style/colors';
import styles from './styles.module.scss';

interface ICustomLinkProps {
  text: string;
  link: string;
  small?: boolean;
  onClick?: () => void;
  type?: string;
}

const CustomLink = ({
  text,
  link,
  small = false,
  onClick,
  type = 'articleContainerLink',
}: ICustomLinkProps) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(link);
    onClick();
  };

  const content = (
    <>
      <span>{text}</span>
      <Icon
        iconType="arrowRight"
        color={colors.hrn.clearBlue1}
        className={clsx(styles.arrow, 'link-arrow', {
          [styles.noPadding]: small,
        })}
        width={small ? 20 : 24}
        height={small ? 20 : 24}
      />
    </>
  );

  if (type === 'hyperlink') {
    return (
      <a
        href={link}
        className={clsx(styles.link, { [styles.smallText]: small })}
        onClick={handleClick}
      >
        {content}
      </a>
    );
  }

  return (
    <LinkText
      to={link}
      className={clsx(styles.link, { [styles.smallText]: small })}
      onClick={onClick}
    >
      {content}
    </LinkText>
  );
};

export default CustomLink;
